// @flow
import Vue from 'vue'
import type { User } from '../../../types/user'
import type { UserState } from './index'
import {
  SET_USER, SET_USER_PROFILE, SET_USER_PROFILE_ADDRESS_FIELD, SET_USER_PROFILE_FIELD,
  SET_USER_VALIDATION_ERRORS, SET_TOKEN, SET_ERROR, CLEAR_USER_VALIDATION_ERROR_BY_PROPERTY_PATH
} from './mutation-types'
import type { PropertyError } from '../../../types/validation-result'
import type { UserProfile } from '../../../types/user-profile'

export default {
  [SET_USER]: (state: UserState, user: ?User) => {
    state.error = null
    state.user = user
  },
  [SET_USER_PROFILE]: (state: UserState, profile: UserProfile) => {
    if (state.user) {
      state.user.profile = profile
    }
  },
  [SET_USER_PROFILE_FIELD]: (state: UserState, { name, value }: { name: string, value: any }) => {
    if (state.user && state.user.profile) {
      state.user.profile[name] = value
    } else {
      Vue.$log.debug('Can not set user profile field if there is no user profile')
    }
  },
  [SET_USER_PROFILE_ADDRESS_FIELD]: (state: UserState, { name, value }: { name: string, value: any }) => {
    if (state.user && state.user.profile && state.user.profile.address) {
      state.user.profile.address[name] = value
    } else {
      Vue.$log.debug('Can not set user profile addressfield if there is no user profile address')
    }
  },
  [SET_USER_VALIDATION_ERRORS]: (state: UserState, errors: PropertyError[]) => {
    state.userValidationErrors = errors
  },
  [CLEAR_USER_VALIDATION_ERROR_BY_PROPERTY_PATH]: (state: UserState, propertyPath: string) => {
    state.userValidationErrors = state.userValidationErrors.filter(
      validationError => validationError.propertyPath !== propertyPath
    )
  },
  [SET_ERROR]: (state: UserState, error: ?Error) => {
    state.user = null
    state.error = error
  },
  [SET_TOKEN]: (state: UserState, token: ?string) => {
    state.token = token
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js